module.exports = __webpack_public_path__ + "img/info_outline.aa366b79.svg";